import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import Autocomplete from "@mui/material";
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import Stack from '@mui/material/Stack';
import { Add } from "@mui/icons-material";
import OutlinedInput from "@mui/material/OutlinedInput";
import ListItemText from "@mui/material/ListItemText";
import { Container } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckIcon from "@mui/icons-material/Check";
import { Chip } from "@mui/material";

import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import FormHelperText from '@mui/material/FormHelperText';
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};


const AddWorkShopUser = () => {
    const history = useHistory();
    const [selectedNames, setSelectedNames] = useState([]);
    const [allroles, setallroles] = useState([]);
    const [disabled, setdisabled] = useState(false);
    const eventid = localStorage.getItem('eventid');
    const [addWorkShopUser, setAddWorkShopUser] = React.useState({
        name: "",
        email: "",
        password: "",
        phone: "",
        date: "",
        address: "",
        details: "",
        error_list: [],
    });


    // const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const handleTogglePassword = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };


    const handleInput = (e) => {
        setAddWorkShopUser({ ...addWorkShopUser, [e.target.name]: e.target.value });

    }
    useEffect(() => {

        axios.get(`api/allroles`).then(res => {
            if (res.status === 200) {
                setallroles(res.data.roles);
            }

        });

    }, []);

    const [assignModule, setassignModules] = useState([]);
    useEffect(() => {
        const eventid = localStorage.getItem('eventid')
        axios.get(`api/modules-access?id=${eventid}`).then(res => {
            if (res.status === 200) {

                setassignModules(res.data.mod);
            }
        });

    }, []);



    const [checkmodules, setCheckedmodules] = useState([]);
    const handlechnage = (e) => {
        const value = e.target.value;
        const checked = e.target.checked;
        if (checked) {
            setCheckedmodules([...checkmodules, value])
        }
        else {
            setCheckedmodules(checkmodules.filter((e) => (e !== value)));
        }

    }

    const [role, setRole] = React.useState('');
    const handleChange = (e) => {
        setRole(e.target.value);
    };
    const AddWorkShopUserFun = (e) => {
        e.preventDefault();
        
        const data = {
            eventid,
            role,
            checkmodules,
            name: addWorkShopUser.name,
            email: addWorkShopUser.email,
            password: addWorkShopUser.password,
            phone: addWorkShopUser.phone,
            date: addWorkShopUser.date,
            address: addWorkShopUser.address,
          

        }
        data.eventid == "" ? setdisabled(false) : data.role == "" ? setdisabled(false) :
      data.checkmodules == "" ? setdisabled(false) : data.name == "" ? setdisabled(false) :
        data.password == "" ? setdisabled(false) : data.phone == "" ? setdisabled(false) : setdisabled(true)
        

        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/orgniserAddWorkshopUser`, data, config).then(res => {
                if (res.data.status === 200) {
                    swal('Success', res.data.message, 'success');
                    //history.push('/admin/reviewer/reviewer-list');
                    window.history.back();
                }
                else {
                    setAddWorkShopUser({ ...addWorkShopUser, error_list: res.data.validate_error })
                }
            });
        });
    }
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        error_list: [],
      });
      React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
          if (res.status === 200) {
            const getHomePageData = res.data.HomePageSetup;
            setAbstractHomeSetup(getHomePageData);
          }
        })
    
      }, [eventid]);
    
    
    
      let backGroundButtonByEvent = "";
      if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
      }
      else {
        backGroundButtonByEvent = '#145348'; // Default background color
      }
      //backgroundColor: backGroundButtonByEvent,
    return (
        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                <h4 sx={{ m: 2, color: '#000000' }} >
                    <Button sx={{
                        float: 'right',
                        marginTop: '2%',
                        backgroundColor: backGroundButtonByEvent,
                        ":hover": {
                            color: "white"
                        }
                    }}
                        color='success'
                        size='small'
                        variant='contained'
                       onClick={()=>history.goBack()}>
                        BAck
                    </Button>
                </h4>
                <Card sx={{ width: '60vw', float: 'center' }} >
                    <CardContent >
                        <Typography component="h1" variant="h5">
                            Add User
                        </Typography>
                        <Box component="form" onSubmit={AddWorkShopUserFun} encType="multipart/form-data" noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={4}>

                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth

                                        label="Name"
                                        autoFocus
                                        name='name'
                                        onChange={handleInput} value={addWorkShopUser.name}
                                        helperText={addWorkShopUser.error_list.name} />
                                </Grid>


                                <Grid item xs={6}>
                                    <TextField
                                        required
                                        fullWidth
                                        id="email"
                                        label="Email Address"
                                        autoComplete="email"
                                        name='email'
                                        onChange={handleInput} value={addWorkShopUser.email}
                                        helperText={addWorkShopUser.error_list.name} />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        type={showPassword ? 'text' : 'password'}
                                        required
                                        fullWidth
                                        label="Password"
                                        id="password"
                                        autoComplete="new-password"
                                        name='password'
                                        onChange={handleInput}
                                        value={addWorkShopUser.password}
                                        helperText={addWorkShopUser.error_list.password}
                                        // onChange={(e) => setPassword(e.target.value)}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton onClick={handleTogglePassword} edge="end">
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }} />
                                </Grid>
                             

                                <Grid item xs={6}>
                                    <TextField
                                        required
                                        fullWidth
                                        label="Phone"
                                        type="text"
                                        name='phone'
                                        onChange={handleInput} value={addWorkShopUser.phone} />
                                </Grid>


                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Address"
                                        autoFocus
                                        name='address' onChange={handleInput} value={addWorkShopUser.address} />
                                </Grid>

                                <Grid item xs={6} >
                                    <TextField
                                        type="Date"
                                        required
                                        fullWidth
                                        autoFocus={true}
                                        label="Date Of Bith"
                                        name='date' onChange={handleInput} value={addWorkShopUser.date} />
                                </Grid>

                              
                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <InputLabel >Role</InputLabel>
                                        <Select defaultValue=""
                                            name='role' onChange={handleChange} value={role}
                                            label="Role">

                                            {
                                                allroles.map((item => {
                                                    return (
                                                        <MenuItem value={item.id} key={item.id}>{item.name}</MenuItem>
                                                    )

                                                }))
                                            }

                                        </Select>
                                        <FormHelperText>{addWorkShopUser.error_list.role} </FormHelperText>
                                    </FormControl>
                                </Grid>
                               
                             
                                <Grid item xs={12} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        id="firstName"
                                        label="Details"
                                        autoFocus
                                        name='details'
                                        multiline
                                        rows={6} onChange={handleInput} value={addWorkShopUser.details} />
                                </Grid>

                                <Grid item xs={12}>
                                    <FormGroup row>
                                        {
                                            assignModule.map((item) => {
                                                return (

                                                    <FormControlLabel required control={<Checkbox />}
                                                        label={item.module}
                                                        onChange={handlechnage}
                                                        value={item.module_id}
                                                        name="checkmodules" key={item.id} />

                                                )
                                            })
                                        }
                                    </FormGroup>
                                    <FormHelperText>{addWorkShopUser.error_list.checkmodules} </FormHelperText>
                                </Grid>
                            </Grid>

                            <Grid container justifyContent="flex-end">
                                <Button
                                disabled={disabled}
                                    type="submit"
                                    variant="contained"
                                    sx={{ mt: 5, backgroundColor: backGroundButtonByEvent, }} >
                                    Add User
                                </Button>
                            </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div>

    );
}

export default AddWorkShopUser;
